/* eslint-disable import/prefer-default-export */
export const SCHEMA = {
  email: {
    emptyEmailMessage: 'Email address is required.',
    invalidEmailMessage: 'Email address is not valid.',
    maxLengthMessage: 'Your email address should be within 64 characters.',
  },
  name: {
    emptyNameMsg: 'Your name must not be empty.',
    invalidNameMsg:
      'Your name must only contain letters, numbers, dots(.), hyphens(-) and slashes(/).',
    maxLengthMessage: 'Your name must be within 40 characters.',
  },
  mobile: {
    invalidContactNumberMessage:
      'Please enter a valid 8-digit Singapore phone number starting with 8 or 9.',
  },
  emailOrPhone: {
    emptyValueMessage: 'Email address or mobile number is required.',
    invalidValueMessage: 'Please enter a valid email or 8-digit Singapore mobile number.',
    maxLengthMessage: 'Email address should be maximum of 64 characters.',
  },
  password: {
    minLengthMessage: 'min8',
    minOneNumberMessage: 'min1Number',
    minOneLetterMessage: 'min1LowerUpperCaseLetter',
  },
  passwordMessage: {
    minLengthText: 'At least 8 characters in length',
    minOneNumberText: 'At least 1 number',
    minOneLetterText: 'At least 1 lower or upper case letter',
  },
  passwordLogin: { emptyPasswordMsg: 'Password is required.' },
  passwordConfirm: {
    emptyPasswordMsg: 'Confirm password is a required field',
    notMatchMsg: 'Passwords must match',
  },
};
